import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query ucceMrds {
  ucceMrds{
    id
    activitiesLimit
    mrdId
    mrdName
    scriptSelector
    channelTypes
  }
}`;

function getUcceMrds() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.ucceMrds);
}

export default getUcceMrds;
